import { makeStyles } from '@material-ui/core/styles'
import TYPES from '@v4/constants/quiz'

const useStyles = makeStyles(
	theme => ({
		root: {
			alignItems: ({ justify }) => justify,
			display: 'flex',
			flexDirection: 'column',
		},
		table: {
			display: 'flex',
			justifyContent: ({ justify }) => justify,
			flexDirection: 'row',
			maxWidth: '100%',
			width: '100%',
			'& :not(:last-child)': {
				borderRightWidth: () => {
					const isRtl = theme.direction === 'rtl'

					return isRtl ? null : 0
				},
				borderLeftWidth: () => {
					const isRtl = theme.direction === 'rtl'

					return isRtl ? 0 : null
				},
			},

			[theme.breakpoints.up(741)]: {
				flexDirection: ({ isDoubleGridTwelveCols }) => (isDoubleGridTwelveCols ? 'column !important' : null),

				'& :not(:last-child)': {
					borderBottom: ({ isDoubleGridTwelveCols }) => (isDoubleGridTwelveCols ? 'none !important' : null),
					borderRightWidth: ({ isDoubleGridTwelveCols }) => (isDoubleGridTwelveCols ? 1 : null),
					borderLeftWidth: ({ isDoubleGridTwelveCols }) => (isDoubleGridTwelveCols ? 1 : null),
				},

				'& div': {
					flexWrap: ({ isDoubleGridTwelveCols }) => (isDoubleGridTwelveCols ? 'nowrap !important' : null),
					alignItems: ({ isDoubleGridTwelveCols }) => (isDoubleGridTwelveCols ? 'center !important' : null),
					justifyContent: ({ isDoubleGridTwelveCols }) => (isDoubleGridTwelveCols ? 'center' : null),
				},
			},

			[theme.breakpoints.down(1020)]: {
				flexDirection: ({ isDoubleGrid }) => (isDoubleGrid ? 'column' : null),

				'& :not(:last-child)': {
					borderBottom: ({ isDoubleGrid }) => (isDoubleGrid ? 'none' : null),
					borderRightWidth: ({ isDoubleGrid }) => (isDoubleGrid ? 1 : null),
					borderLeftWidth: ({ isDoubleGrid }) => (isDoubleGrid ? 1 : null),
				},

				'& div': {
					flexWrap: ({ isDoubleGrid, labelCount }) => (isDoubleGrid && labelCount === 1 ? 'wrap' : null),
					alignItems: ({ isDoubleGrid, labelCount }) => (isDoubleGrid && labelCount === 1 ? 'center' : null),
					justifyContent: ({ isDoubleGrid, labelCount }) =>
						isDoubleGrid && labelCount === 1 ? 'center' : null,
				},
			},

			[theme.breakpoints.down(740)]: {
				width: '100% !important',
				flexDirection: 'column !important',
				'& :not(:last-child)': {
					borderBottom: 'none !important',
					borderRightWidth: () => {
						return 1
					},
					borderLeftWidth: () => {
						const isRtl = theme.direction === 'rtl'

						return isRtl ? 1 : null
					},
				},
			},
		},
		cell: {
			display: 'flex',
			padding: theme.spacing(3, 1.6),
			flexWrap: 'nowrap',
			alignItems: 'center',
			borderWidth: 1,
			flexDirection: 'column-reverse',
			borderStyle: 'solid',
			borderColor: 'currentColor',
			flex: 1,
			width: ({ isDoubleGridTwelveCols, labelCount }) => {
				if (isDoubleGridTwelveCols) return '100%'

				return `${100 / labelCount}%`
			},

			[theme.breakpoints.up(741)]: {
				width: ({ isDoubleGridTwelveCols }) => (isDoubleGridTwelveCols ? '100% !important' : null),
				flexDirection: ({ isDoubleGridTwelveCols }) => (isDoubleGridTwelveCols ? 'row !important' : null),
				padding: ({ isDoubleGridTwelveCols }) => (isDoubleGridTwelveCols ? theme.spacing(1.6, 3) : null),
				flexWrap: ({ isDoubleGridTwelveCols }) => (isDoubleGridTwelveCols ? 'nowrap !important' : null),
				'& $control': {
					width: ({ isDoubleGridTwelveCols }) => (isDoubleGridTwelveCols ? theme.spacing(6) : null),
				},
			},

			[theme.breakpoints.down(1020)]: {
				width: ({ isDoubleGrid }) => (isDoubleGrid ? '100%' : null),
				flexDirection: ({ isDoubleGrid }) => (isDoubleGrid ? 'column' : null),
				padding: ({ isDoubleGrid }) => (isDoubleGrid ? theme.spacing(1.6, 3) : null),
				flexWrap: ({ isDoubleGrid }) => (isDoubleGrid ? 'nowrap' : null),
				'& $control': {
					width: ({ isDoubleGrid }) => (isDoubleGrid ? theme.spacing(6) : null),
				},
				'& $group': {
					marginTop: ({ isDoubleGrid }) => (isDoubleGrid ? 'unset' : null),
					flexDirection: ({ isDoubleGrid }) => (isDoubleGrid ? 'row' : null),

					'& label': {
						flexDirection: ({ isDoubleGrid }) => (isDoubleGrid ? 'row-reverse' : null),
					},
				},
			},

			[theme.breakpoints.down(740)]: {
				width: '100% !important',
				flexDirection: 'row !important',
				padding: `${theme.spacing(1.6, 3)} !important`,
				flexWrap: 'nowrap !important',
				'& $control': {
					width: `${theme.spacing(6)} !important`,
				},
				'& $group': {
					marginTop: 'unset !important',
					flexDirection: 'column !important',

					'& label': {
						flexDirection: 'row-reverse !important',
					},
				},
			},
		},
		group: {
			display: 'flex',
			flexWrap: 'nowrap',
			marginTop: 'auto',

			[theme.breakpoints.up(741)]: {
				marginTop: ({ isDoubleGridTwelveCols }) => (isDoubleGridTwelveCols ? 'unset' : null),
			},
		},
		radio: {
			position: 'relative',
			minWidth: 26,
			padding: 2,
			'& div': {
				backgroundColor: 'transparent',
				borderRadius: '50%',
			},
			'&:hover': {
				backgroundColor: 'transparent',
			},
			[theme.breakpoints.up('sm')]: {
				padding: 6,
			},
		},
		control: {
			margin: 0,
		},
		label: {
			textAlign: 'center',
		},
		content: {
			display: 'inline-flex',
			flexDirection: 'column',
			width: '100%',
			maxWidth: ({ count }) => {
				switch (count) {
					case 1:
					case 2:
						return theme.spacing(22)
					case 3:
					case 4:
						return theme.spacing(44)
					case 5:
					case 6:
						return theme.spacing(66)
					default:
						return null
				}
			},
		},
		row: {
			display: 'flex',
			flexWrap: 'nowrap',
			alignItems: ({ justify }) => justify,
			justifyContent: 'space-between',
			margin: theme.spacing(0, -0.8),
			width: `calc(100% + ${theme.spacing(1.6)})`,
			maxWidth: `calc(100% + ${theme.spacing(1.6)})`,

			[theme.breakpoints.down(1020)]: {
				margin: ({ isDoubleGrid }) => (isDoubleGrid ? '0 !important' : null),
				width: ({ isDoubleGrid }) => (isDoubleGrid ? '100%' : null),
				maxWidth: ({ isDoubleGrid }) => (isDoubleGrid ? '100%' : null),
			},

			[theme.breakpoints.down(740)]: {
				margin: '0 !important',
				width: '100% !important',
				maxWidth: '100% !important',
			},
		},
		mark: {
			width: '30%',
			flexGrow: 1,
			'&:nth-child(2)': {
				textAlign: 'center',
			},
			'&:last-child': {
				textAlign: 'right',
			},
		},
		[TYPES.DIVIDED_SCALE]: {
			'& $checkbox': {
				[theme.breakpoints.down('xs')]: {
					padding: 2,
				},
			},
		},
		[TYPES.RADIO]: {
			'& $control': {
				width: theme.spacing(4),
				margin: 0,
			},
			'& $checkbox': {
				alignSelf: 'unset',
			},
			[theme.breakpoints.down('sm')]: {
				'& $control': {
					width: '6%',
				},
			},
		},
		checkbox: {
			padding: 6,
			margin: 0,
		},

		radioLabel: {
			[theme.breakpoints.up(741)]: {
				flexDirection: ({ isDoubleGridTwelveCols }) => (isDoubleGridTwelveCols ? 'row-reverse' : null),
			},
		},

		editableLabel: {
			[theme.breakpoints.up(741)]: {
				marginBottom: ({ isDoubleGridTwelveCols }) => (isDoubleGridTwelveCols ? 0 : null),
				width: ({ isDoubleGridTwelveCols }) => (isDoubleGridTwelveCols ? 1 : null),
				flexGrow: ({ isDoubleGridTwelveCols }) => (isDoubleGridTwelveCols ? 1 : null),
			},
			[theme.breakpoints.down(1020)]: {
				marginTop: ({ isDoubleGrid }) => (isDoubleGrid ? theme.spacing(1) : null),
				marginBottom: 0,
			},
		},
	}),
	{ name: 'Questions-AnswerTypes-RangeRadioButtons' },
)

export default useStyles
